import { render, staticRenderFns } from "./AuthShell.vue?vue&type=template&id=24ad4e9e&scoped=true"
import script from "./AuthShell.vue?vue&type=script&lang=ts"
export * from "./AuthShell.vue?vue&type=script&lang=ts"
import style0 from "./AuthShell.vue?vue&type=style&index=0&id=24ad4e9e&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/auth/auth.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad4e9e",
  null
  
)

export default component.exports